import { render, staticRenderFns } from "./OthersSettings.vue?vue&type=template&id=f9915ff4"
import script from "./OthersSettings.vue?vue&type=script&lang=js"
export * from "./OthersSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports